import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

const widgetStatusClass = {
  draft: 'grey-salt',
  scheduled: 'blue-soft',
  active: 'green-jungle',
  paused: 'yellow',
  expired: 'red-soft',
  archived: 'grey-cascade'
}

export const getStatus = (startDate, endDate, value) => {
  if (value === 'active') {
    return value
  }

  const start = moment(startDate)
  const end = moment(endDate)
  const current = moment()

  if (start.isSameOrBefore(current) && end.isAfter(current)) {
    return 'draft'
  }

  if (start.isAfter(current) && end.isAfter(current)) {
    return 'scheduled'
  }
  if (start.isBefore(current) && end.isBefore(current)) {
    return 'expired'
  }

  return value || 'draft'
}

const StatusField = ({ input: { value, onChange }, startDate, endDate }) => {
  const status = getStatus(startDate, endDate, value)

  // istanbul ignore next
  if (status !== value) {
    onChange(status)
  }

  return (
    <label
      className={'br-experience-status label ' + widgetStatusClass[status]}
    >
      {status}
    </label>
  )
}

StatusField.propTypes = {
  input: PropTypes.shape({ value: PropTypes.string, onChange: PropTypes.func }),
  startDate: PropTypes.number,
  endDate: PropTypes.number
}

export default StatusField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/status/index.js